<div data-e2e="image" class="img-pan-zoom" [ngClass]="{'ui blank': !imageSrcUrl}">
  <div class="ui active inverted dimmer" *ngIf="isLoading && imageSrcUrl">
    <div class="ui text loader" i18n>Loading...</div>
  </div>
  <div class="ui grid inline fields edit-view-controls" *ngIf="editMode" [hidden]="isLoading">
    <div class="ten wide field">
      {{fileData[0] | truncate: 50: true}}
    </div>
    <div class="ui icon six wide field remove-photo" data-e2e="close">
      <div class="icon-text" (click)="removePhoto.emit()" i18n>Remove Photo</div>
    </div>
  </div>
  <div *ngIf="imageSrcUrl" class="main-container">
    <image-pan-zoom #imagePanZoom [ngClass]="{'edit-mode': editMode}" crossOrigin="Anonymous" [imageSrcUrl]="imageSrcUrl" (onImageLoadComplete)="imageLoadComplete()" [style.visibility]="isLoading ? 'hidden': 'visible'" [fitToContainer]="fitToContainer"></image-pan-zoom>
    <div class="actions-container" [ngClass]="{'edit-mode': editMode}">
      <div class="actions clearfix" [hidden]="isLoading || hideZoomLevel">
        <div class="push">&nbsp;</div>
        <div class="ui action input">
          <button (click)="imagePanZoom.zoomOut()" class="right ui icon button"><i class="close icon"><svg   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 2"><path fill="#fff" d="M0 0h32v2H0z"/></svg></i></button>
          <input disabled type="text" class="zoom-range" [(ngModel)]="imagePanZoom.percentageZoomText">
          <button (click)="imagePanZoom.zoomIn()" class="left ui icon button"><i class="close icon"><svg   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#757575" d="M20 9h-9V0H9v9H0v2h9v9h2v-9h9V9z"/></svg></i></button>
          <button *ngIf="editMode" (click)="rotateInDegrees(-90)" class="ui icon button rotate-btn"><i class="close icon"><svg   width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg"><g fill="#757575" fill-rule="nonzero"><path fill-opacity=".1" d="M7 5.5l-5 5 5 5 5-5z"/><path d="M9.902 4.012A6.5 6.5 0 0 1 9.5 17v-1a5.5 5.5 0 0 0 .43-10.983l1.63 1.63-.706.707L8 4.5l2.854-2.854.707.708-1.659 1.658zM7 6.914L3.414 10.5 7 14.086l3.586-3.586L7 6.914zM7 5.5l5 5-5 5-5-5 5-5z"/></g></svg></i></button>
        </div>
        <div class="push right">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!imageSrcUrl">
    <svg   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 67.7"><path fill="#FFF" d="M1.8 2.8h56.7v62.8H1.8z"/><path fill="none" stroke="#757575" stroke-width="2" stroke-miterlimit="10" d="M1.8 2.8h56.7v62.8H1.8V2.8zM29.2 15H11.9m36.5 8.1H11.9m17.3 8.1H11.9m37.5 8.1H11.9"/></svg>
    <ng-container i18n>No Photo Available</ng-container>
  </ng-container>
</div>